"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  border-radius: 15px;\n  border: 3px dashed #ccc;\n  color: #666;\n  padding: 3em;\n  font-size: 18px;\n\n  & h1,\n  & h2 {\n    font-size: 2em;\n    font-weight: bold;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var placeholderClass = (0, _emotion.css)(_templateObject());

var DefaultText = function DefaultText() {
  return _react["default"].createElement("div", null, _react["default"].createElement("h1", null, "Content Placeholder"), _react["default"].createElement("p", null, "Stuff coming soon!"));
};

var IssueText = function IssueText(_ref) {
  var issue = _ref.issue;
  return _react["default"].createElement("div", null, _react["default"].createElement("h1", null, "Card In Progress"), _react["default"].createElement("a", {
    href: "https://github.com/hackoregon/civic/issues/".concat(issue)
  }, "View progress on GitHub"));
};

var Placeholder = function Placeholder(_ref2) {
  var issue = _ref2.issue,
      children = _ref2.children;
  return _react["default"].createElement("div", {
    className: placeholderClass
  }, issue ? _react["default"].createElement(IssueText, {
    issue: issue
  }) : children || _react["default"].createElement(DefaultText, null));
};

Placeholder.displayName = "Placeholder";
Placeholder.propTypes = {
  children: _propTypes["default"].node,
  issue: _propTypes["default"].string
};
IssueText.propTypes = {
  issue: _propTypes["default"].string
};
var _default = Placeholder;
exports["default"] = _default;